"use strict";Object.defineProperty(exports, "__esModule", {value: true}); const avatarColors = [
  "#B2E6A1", "#E2AE80", "#EC83B5", "#79C9DE", "#EC8383",
]; exports.avatarColors = avatarColors

 const getAvatarColorFromString = (str) => {
  const sum = str.split('').reduce((acc, c) => acc + c.charCodeAt(0), 0)
  return exports.avatarColors[sum % exports.avatarColors.length]
}; exports.getAvatarColorFromString = getAvatarColorFromString
